import { Course } from '../../models/course';
import { CoursesEndpoints } from '../../endpoint';
import { mapCourse } from '../../mappers/api2_0/course.mapper';

const getCourses: () => Promise<Course[]> = async () => {
  return CoursesEndpoints.getCourses().then(response => {
    return response.resources.map(mapCourse);
  });
};

const CourseService = {
  getCourses,
};

export default CourseService;
